import { EntityTemplateVariables } from '@tools/interfaces/template';
import { getCenterFieldsForEntity, templateCenter } from './template-center';
import { templateUser } from './template-user';

export const templateGlobal: EntityTemplateVariables = {
  fields: [
    {
      label: 'templates.global.today.label',
      contentValue: '{{ now | date("d/m/Y") }}',
      description: 'templates.global.today.description',
    },
    {
      label: 'templates.global.now_time.label',
      contentValue: '{{ now | date("H:i") }}',
      description: 'templates.global.now_time.description',
    },
    {
      label: 'templates.global.pagebreak.label',
      contentValue: '{{ pagebreak }}',
      description: 'templates.global.pagebreak.description',
    },
    ...templateCenter.fields,
    ...templateUser.fields,
  ],
  related: [
    {
      relationName: 'center',
      relationType: 'simple',
      label: 'templates.global.center.label',
      description: 'templates.global.center.description',
      fields: getCenterFieldsForEntity(''),
    },
    {
      relationName: 'user',
      relationType: 'simple',
      label: 'templates.global.user.label',
      description: 'templates.global.user.description',
      fields: templateUser.fields,
    },
  ],
  relatedInLoop: [],
};
